import React, {Component} from "react"
import {createMuiTheme, MuiThemeProvider} from "@material-ui/core/styles"
import MUIDataTable from "mui-datatables-bitozen"
import FlexView from 'react-flexview'
import LoadingBar from 'react-top-loading-bar'
import {connect} from 'react-redux'
import API from "../../../../Services/Api";

const ct = require("../../../../modules/custom/customTable")
const getMuiTheme = () => createMuiTheme(ct.customTable())
const options = ct.customOptions6()

class EmployeeSearchForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            rawData: [],
            employeeCount: 0,
            table_limit: 10,
            table_page: 0,
            table_query: ""
        }
    }

    componentDidMount() {
        // console.log(this.props.data)
        this.getData(this.state.table_page, this.state.table_limit)
    }

    getData = async (page, limit) => {
        if (this.props.data === 'Employee') {
            await this.getEmployee(page, limit)
        }
        if (this.props.data === 'Outsource') {
            await this.getEmployeeOut(page, limit)
        }
    }

    async getEmployee(page, limit) {
        let payload = {
            limit: limit,
            offset: page,
            companyId: this.props.stateData.companyId,
            locationId: null,
            jobId: null,
            levelId: null,
            status: null,
            filter: this.state.table_query,
        }

        let res = await API.create('MASTERDATA_EMPL_EKSAD').postGetEmplList(payload)
        if (res.ok) {
            if (res.data.data === null) {
                this.setState({dataTable: []})
            } else {
                // console.log(JSON.stringify(res.data.data, null, 2));
                let dataTable = res.data.data && res.data.data.listEmplList.map((value) => {
                    const {emplName, nip, emplStatus, position} = value;
                    return [
                        emplName,
                        nip,
                        emplStatus,
                        position,
                    ]
                })
                this.setState({
                    rawData: res.data.data && res.data.data.listEmplList,
                    dataTable,
                    employeeCount: res.data.data && res.data.data.dataOfRecord
                })
                this.onFinishFetch();
            }
        }
    }

    async getEmployeeOut(page, limit) {
        let payload = {
            limit: limit,
            offset: page,
            companyId: null,
            locationId: null,
            jobId: null,
            levelId: null,
            status: null,
            filter: this.state.table_query,
        }

        let res = await API.create('MASTERDATA_EMPL_EKSAD').postGetEmplOutList(payload)
        if (res.ok) {
            if (res.data.data === null) {
                this.setState({dataTable: []})
            } else {
                // console.log(JSON.stringify(res.data.data, null, 2));
                let dataTable = res.data.data && res.data.data.emplList.map((value) => {
                    const {emplName, nip, emplStatus, position} = value;
                    return [
                        emplName,
                        nip,
                        emplStatus,
                        position,
                    ]
                })
                this.setState({
                    rawData: res.data.data && res.data.data.emplList,
                    dataTable,
                    employeeCount: res.data.data && res.data.data.dataOfRecord
                })
                this.onFinishFetch();
            }
        }
    }

    startFetch = () => {
        this.LoadingBar.continousStart();
    };

    onFinishFetch = () => {
        if (typeof this.LoadingBar === "object") this.LoadingBar.complete()
    }

    columns = [
        {
            name: "Employee",
            options: {
                customBodyRender: (val, tableMeta) => {
                    let { rawData, imageUser } = this.state
                    let photo = null
                    let empId = rawData[tableMeta.rowIndex] && rawData[tableMeta.rowIndex].employeeID
                    if (empId) {
                        photo = imageUser[empId]
                    }
                    return (
                        <FlexView column vAlignContent="center">
                            <FlexView>
                                <span style={{ fontWeight: 'bold', fontSize: 15 }}>
                                    {tableMeta.rowData[0] + " (" + tableMeta.rowData[2] + ")"}
                                </span>
                            </FlexView>
                            <FlexView>
                                <span style={{ fontSize: "10px" }}>
                                    {tableMeta.rowData[3]}
                                </span>
                            </FlexView>
                        </FlexView>

                    );
                }
            }
        },
        "Employee Status",
        // {
        //     name: "Employee Status",
        //     options: {
        //         customBodyRender: (val, tableMeta) => {
        //             return (
        //                 <FlexView column vAlignContent="center">
        //                     <FlexView>
        //                         <span>
        //                             {tableMeta.rowData[2]}
        //                         </span>
        //                     </FlexView>
        //                 </FlexView>

        //             );
        //         }
        //     }
        // },
        { name: '', options: { display: false, viewColumns: false, } },
        {
            name: "Action",
            options: {
                customBodyRender: (val, tableMeta) => {
                    return (
                        <div>
                            <button
                                type="button"
                                className="btnAct"
                                onClick={() => this.props.onChoose(this.state.rawData[tableMeta.rowIndex], this.props.onClickClose())}
                            >
                                <i className="fa fa-1x fa-plus"
                                    style={{ backgroundColor: 'transparent', color: '#004c97', fontSize: 20 }} />
                            </button>
                        </div>
                    );
                }
            }
        }
    ];

    render() {
        let {employeeCount, table_query} = this.state
        let tableOptions = {
            ...options,
            serverSide: true,
            count: employeeCount,
            searchText: table_query,
            onTableChange: (action, tableState) => {
                switch (action) {
                    case 'changePage':
                        this.setState({table_page: tableState.page})
                        this.getData(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'changeRowsPerPage':
                        this.setState({table_limit: tableState.rowsPerPage})
                        this.getData(tableState.page, tableState.rowsPerPage);
                        break;
                    case 'search':
                        let searchText = tableState.searchText ? tableState.searchText : ""
                        this.setState({table_query: searchText}, () => {
                            this.getData(tableState.page, tableState.rowsPerPage)
                        })
                        break;
                    default:
                        break;
                }
            }
        }
        return (
            <div className={"app-popup app-popup-show"}>
                <LoadingBar onRef={ref => (this.LoadingBar = ref)}/>
                <div className="padding-top-20px"/>
                <div className="popup-content background-white border-radius" style={{ width: "650px" }}>
                    <div className="popup-panel grid grid-2x">
                        <div className="col-1">
                            <div className="popup-title">
                                Employee
                            </div>
                        </div>
                        <div className="col-2 content-right">
                            <button
                                type="button"
                                className="btn btn-circle btn-grey"
                                onClick={this.props.onClickClose}
                            >
                                <i className="fa fa-lg fa-times"/>
                            </button>
                        </div>
                    </div>

                    <form action="#">
                        <div className="padding-15px grid-mobile-none">
                            <div className="margin-bottom-15px">
                                <MuiThemeProvider theme={getMuiTheme()}>
                                    <MUIDataTable
                                        key={employeeCount}
                                        title={"Employee List"}
                                        subtitle={"Employee"}
                                        data={this.state.dataTable}
                                        columns={this.columns}
                                        options={tableOptions}
                                    />
                                </MuiThemeProvider>
                            </div>
                        </div>
                        <div className="padding-15px border-top">
                            <div className="grid grid-2x">
                                <div className="col-1"/>
                                <div className="col-2 content-right">
                                    <button
                                        style={{marginLeft: "15px"}}
                                        className="btn btn-primary"
                                        type="button"
                                        onClick={this.props.onClickClose}
                                    >
                                        <span>CLOSE</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="padding-bottom-20px"/>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        auth: state.auth,
    }
}

export default connect(mapStateToProps)(EmployeeSearchForm);
